import { render } from "./ArchiveCase.vue?vue&type=template&id=21a58f08"
import script from "./ArchiveCase.vue?vue&type=script&lang=js"
export * from "./ArchiveCase.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/cases/ArchiveCase.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "21a58f08"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('21a58f08', __exports__)) {
    console.log('reload')
    api.reload('21a58f08', __exports__)
  }
  
  module.hot.accept("./ArchiveCase.vue?vue&type=template&id=21a58f08", () => {
    console.log('re-render')
    api.rerender('21a58f08', render)
  })

}


export default __exports__